let config = {
  base: (process.env.REACT_APP_ERP_BASE_URL || "").replace(/\/$/, ""),
  expired: () => window.dispatchEvent(new Event("session-expired")),
};
export const configureHttp = (options) => {
  config = { ...config, ...options };
};
export const clearSession = () =>
  ["authToken", "user", "empresa", "permissions"].forEach((k) =>
    localStorage.removeItem(k)
  );
export const apiUrl = (path) => {
  const base = String(config.base || "").trim().replace(/\/+$/, "");
  if (!base)
    throw new Error("Configura REACT_APP_ERP_BASE_URL para conectar el ERP.");
  try {
    const url = new URL(base);
    if (!["http:", "https:"].includes(url.protocol) || !url.hostname)
      throw new Error("invalid protocol");
  } catch (_) {
    throw new Error("Revisa REACT_APP_ERP_BASE_URL: debe ser una URL válida que comience con http:// o https://. Corrige el .env y reinicia npm start.");
  }
  return `${base}/${String(path).replace(/^\//, "")}`;
};
export async function request(
  path,
  { body, headers = {}, responseType = "json", ...options } = {}
) {
  const token = localStorage.getItem("authToken");
  const plain =
    body &&
    !(body instanceof FormData) &&
    !(body instanceof URLSearchParams) &&
    typeof body !== "string";
  const response = await fetch(
    apiUrl(
      path === "login" || path.startsWith("comercial-app/")
        ? path
        : `comercial-app/erp/${path}`
    ),
    {
      ...options,
      body: plain ? JSON.stringify(body) : body,
      headers: {
        Accept: responseType === "blob" ? "*/*" : "application/json",
        ...(plain || typeof body === "string"
          ? { "Content-Type": "application/json" }
          : {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...headers,
      },
    }
  );
  const renewed =
    response.headers.get("Authorization") || response.headers.get("X-Token");
  if (renewed && response.ok)
    localStorage.setItem("authToken", renewed.replace(/^Bearer\s+/i, ""));
  if (response.status === 401) {
    clearSession();
    config.expired();
  }
  if (!response.ok) {
    let d = {};
    try {
      d = await response.json();
    } catch (_) {}
    if (
      ["token_blacklisted", "token_expired", "token_invalid"].includes(
        d.error
      ) ||
      ["token_blacklisted", "token_expired", "token_invalid"].includes(d.code)
    ) {
      clearSession();
      config.expired();
    }
    const e = new Error(
      d.message || d.mensaje || d.msg || `Error ${response.status}`
    );
    e.status = response.status;
    e.body = d;
    throw e;
  }
  if (response.status === 204) return null;
  if (responseType === "blob") return response.blob();
  const data = await response.json();
  if (data?.success === false)
    throw new Error(
      data.message ||
        data.mensaje ||
        data.msg ||
        "No se pudo completar la operación"
    );
  return data;
}
export const requestBlob = (path, options = {}) =>
  request(path, { ...options, responseType: "blob" });
export const erp = (path, options) =>
  request(`comercial-app/erp/${path}`, options);
